import { InvoiceEventClassification } from './invoice-event-classification'
import { InvoiceEventHistory } from './invoice-event-history-model'

type InvoiceEventModel = {
  uniqueId: string
  issuerName: string
  issuerCnpj: string
  issuedAt: Date
  invoiceNumber: string
  invoiceAmount: number
  invoiceAttachment: string
  authorizationId: string
  status: InvoiceEvent.Status
  classification: InvoiceEventClassification.Enum | undefined
  histories: InvoiceEventHistory.Model[]
}

export namespace InvoiceEvent {
  export type Model = InvoiceEventModel

  export enum Status {
    CREATED = 'CREATED',
    PENDING = 'PENDING',
    CONCILIATED = 'CONCILIATED',
    UNIDENTIFIED = 'UNIDENTIFIED',
    FAILED = 'FAILED',
    IGNORED = 'IGNORED'
  }
}
